import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { Observable } from "rxjs";
import { AlertService, BaseMaterialDatatableComponent, ConfirmDialogComponent } from "@impacgroup/angular-baselib";
import { V2AdminSimCardListItemResponseDTO } from "@impacgroup/doerr-wildkamera-api-dtos";
import { SimCardsService } from "./simcards.service";
import { SimCardsMainComponent } from "./simcards.main.component";

@Component({
    selector: "app-simcards",
    templateUrl: "./simcards.component.html",
    styleUrls: ["simcards.component.scss"],
    standalone: false
})
export class SimCardsComponent extends BaseMaterialDatatableComponent<V2AdminSimCardListItemResponseDTO> implements OnInit {
    public UTCDATEFORMAT: string = "";

    constructor(
        private simCardsService: SimCardsService,
        private translateService: TranslateService,
        private modalService: BsModalService,
        private alertService: AlertService,
        private router: Router,
        private route: ActivatedRoute,
        parent: SimCardsMainComponent
    ) {
        super({
            stateSaveConfig: {
                stateSaveMode: simCardsService.datatableStateSaveMode,
                stateSaveComponent: parent,
                stateSaveStorageKey: "dtstate_simcards_list"
            },
            sortState: {
                active: "created",
                direction: "desc"
            },
            displayedColumns: ["iccid", "imei", "state", "user", "firstActivation", "pendingSince", "scheduledSuspensionDate", "created", "updated", "actions", "details"],
            listService: simCardsService
        });

        this.UTCDATEFORMAT = this.simCardsService.UTCDATEFORMAT;
    }

    viewSimCard(id?: string) {
        this.router.navigate([id], { relativeTo: this.route });
    }

    activateSimCard(id?: string) {
        this.confirmStateChange("activate", id, (simCardId) => this.simCardsService.activateSimCard(simCardId));
    }

    deactivateSimCard(id?: string) {
        this.confirmStateChange("deactivate", id, (simCardId) => this.simCardsService.deactivateSimCard(simCardId));
    }

    private confirmStateChange(action: "activate" | "deactivate", id: string | undefined, request: (id: string) => Observable<Object>) {
        const initialState = {
            title: this.translateService.instant(`simcards.list.${action}.title`),
            message: this.translateService.instant(`simcards.list.${action}.message`),
            closeBtnName: this.translateService.instant("global.buttons.close"),
            confirmBtnName: this.translateService.instant("global.buttons.ok")
        };
        const bsModalRef = this.modalService.show(ConfirmDialogComponent, { initialState });
        if (bsModalRef.content) {
            bsModalRef.content.confirmCallback = () => {
                if (!id) {
                    return;
                }

                this.subscriptions.push(
                    request(id).subscribe(() => {
                        this.alertService.addSuccess(this.translateService.instant(`simcards.list.${action}.success`));
                        this.loadData();
                    })
                );
            };
        }
    }
}
